import { useState } from 'react';
import { ModuleDataHandler } from '../helpers/handleReportCalc';
import TBodyRow from './TBodyRow';
import { useQuery } from '../../../../hooks/UseQuery';
interface IProps {
  moduleData: any;
  numberOfDay: any;
  isView: boolean;
}

const TBody = ({ moduleData, isView, numberOfDay }: IProps) => {
  const department_name = useQuery('department_name');
  const [render, setRender] = useState<boolean>(false);
  return (
    <tbody>
      {moduleData?.list?.length > 0 &&
        moduleData?.list?.map((item: any, index: number) => (
          <TBodyRow
            {...{
              moduleData,
              item,
              index,
              isView,
              numberOfDay,
              setRender,
            }}
          />
        ))}
      {moduleData?.list?.length > 0 && (
        <tr style={{ background: '#f1f3f5' }}>
          <td colSpan={4}>{`TOTAL`}</td>
          <td>{moduleData.total_spl_allowance}</td>
          <td>{moduleData.total_salary}</td>
          <td>{moduleData.total_duty}</td>
          <td>{moduleData.total_sun_ot}</td>
          <td>{moduleData.total_total_1}</td>

          <td>{moduleData.total_ot}</td>

          <td>{moduleData.total_duty_amt}</td>
          <td>{moduleData.total_ot_amt}</td>
          <td>{moduleData.total_total_2}</td>

          <td>{moduleData.total_advance}</td>
          <td>{moduleData.total_total_3}</td>

          <td>{moduleData.total_tea}</td>
          <td>{moduleData.total_pf_esi}</td>
          <td>{moduleData.total_cheque_payment}</td>
          <td>{moduleData.total_net_pay}</td>
          <td>{moduleData.total_previous_bal}</td>
          <td>{moduleData.total_cash_payable}</td>
          <td>{moduleData.total_cheque_amount}</td>
        </tr>
      )}
    </tbody>
  );
};

export default TBody;
